/**
 * Label for the MLS listing "See matches" button. Singular/plural and the
 * zero case need to read naturally rather than "See 0 matches" or "See 1
 * matches".
 */
export function formatMatchCountLabel(totalMatches) {
  // totalCount can arrive as a string off a MySQL-backed count query - coerce
  // before the strict === checks below, or "1" reads as plural ("See 1
  // matches") and falls straight through to the default case.
  const parsed = Number(totalMatches);
  const n = Number.isFinite(parsed) && parsed > 0 ? Math.trunc(parsed) : 0;
  if (n === 0) return "No matches";
  if (n === 1) return "See 1 match";
  return `See ${n} matches`;
}
